// extracted by mini-css-extract-plugin
export default {"container":"Search_container__LATyd","icon":"Search_icon__Mw9QJ","input":"Search_input__UMCuJ"};